export default __webpack_public_path__ + "static/media/sub-category-coworking-MeetingRoomSpace.4f4be28d.jpg";